module.exports = __webpack_public_path__ + "img/where-avatar-is.5f28e1c7.png";